<template>
    <BaseUiBadge
        color="simplo"
        class="w-fit whitespace-nowrap"
        content-class="font-bold"
        pill
    >
        {{ `- ${percentage ?? 0} %` }}
    </BaseUiBadge>
</template>

<script lang="ts" setup>

const {
    percentage,
} = defineProps<{
    percentage: number | null | undefined
}>()

</script>

<style lang="scss" scoped>

</style>
